import useDeviceType from './useDeviceType';
import { MOBILE_PLACEHOLDER_HEIGHT, DESKTOP_PLACEHOLDER_HEIGHT } from '../constants/index';
import { getExperienceType } from '../utils/bundle-features-utils';

const useGetPlaceholderHeight = (product) => {
  const { isMobile } = useDeviceType();
  const experienceType = getExperienceType(product);
  const placeholderObject = isMobile ? MOBILE_PLACEHOLDER_HEIGHT?.[experienceType]
    : DESKTOP_PLACEHOLDER_HEIGHT?.[experienceType];
  return placeholderObject || {};
};

export default useGetPlaceholderHeight;